import { defineComponent, nextTick, PropType } from "vue";
import { OfferJson } from "../../OrderForm";
import OrderLayout from "../../layouts/OrderLayout";
import StepSmeFormConsents from "./StepSmeFormConsents";
import StepSmeFormInvoice from "./StepSmeFormInvoice";
import StepSmeFormSummary from "./StepSmeFormSummary";
import StepSmeFormVerify from "./StepSmeFormVerify";
import Utils from "../../utils/Utils";
import { SmeOrderJson } from "../../utils/SmeUtils";

export default defineComponent({
    components: {
        StepSmeFormVerify,
        StepSmeFormInvoice,
        StepSmeFormConsents,
        StepSmeFormSummary,
        OrderLayout,
    },

    template: `
        <OrderLayout :options="options" :step="step" :wrapper="932" :title="step_title" @offer:change="setMainStep('sme.offer', options.offer)">
            <div class="StepForm">
                <StepSmeFormVerify :options="options" :step="step" @next="setStep('invoice', options.offer)" @goto="gotoStep" @back="$emit('back')" />
                <StepSmeFormInvoice :options="options" :step="step" @next="setStep('consents', options.offer)" @goto="gotoStep" />
                <StepSmeFormConsents :options="options" :step="step" @next="setStep('summary', options.offer)" @goto="gotoStep" />
                <StepSmeFormSummary :options="options" :step="step" @goto="gotoStep" />
            </div>
        </OrderLayout>
    `,

    emits: [
        'back',
    ],

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
    },

    computed: {
        step() {
            if (this.isStep('verify')) {
                return 1;
            } else if (this.isStep('invoice')) {
                return 2;
            } else if (this.isStep('consents')) {
                return 3;
            } else if (this.isStep('summary')) {
                return 4;
            }
        },

        step_title() {
            if (this.isStep('verify')) {
                return `Sprawdź poprawność danych`;
            } else if (this.isStep('invoice')) {
                return `Sprawdź poprawność danych`;
            } else if (this.isStep('consents')) {
                return `Coraz bliżej...`;
            } else if (this.isStep('summary')) {
                return `To już!<br>Sprawdź, czy wszystko jest OK`;
            }
        },
    },

    watch: {
        '$root.step'(step: string) {
            let $el = null;

            if (this.isStep('verify')) {
                $el = $('.StepBox--1');
            } else if (this.isStep('invoice')) {
                $el = $('.StepBox--2');
            } else if (this.isStep('consents')) {
                $el = $('.StepBox--3');
            } else if (this.isStep('summary')) {
                $el = $('.StepBox--4');
            }

            if ($el) {
                nextTick(() => {
                    Utils.scrollToEl($el);
                });
            }
        },
    },

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.OrderLayout, .StepForm'));
        });
    },

    methods: {
        isStep(val: string) {
            return Utils.isStep('sme.form.' + val);
        },

        setStep(step: string, offer?: OfferJson) {
            Utils.setStep('sme.form.' + step, offer);
        },

        setMainStep(step: string, offer?: OfferJson) {
            Utils.setStep(step, offer);
        },

        async gotoStep(step: number) {
            const offer: OfferJson = this.options.offer;

            switch (step) {
                case 1:
                    return this.setStep('verify', offer);

                case 2:
                    return this.setStep('invoice', offer);

                case 3:
                    return this.setStep('consents', offer);

                case 4:
                    return this.setStep('summary', offer);
            }
        },
    },

    setup(props, ctx) {
        Utils.hideGreenTerms();
    },
});
